module.exports = __webpack_public_path__ + "static/media/profileIconGreen.c36f4ecb.svg";